import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div
      className="min-h-screen bg-background text-foreground flex flex-col items-center justify-center px-6 text-center"
      style={{
        paddingTop: "max(3rem, env(safe-area-inset-top))",
        paddingBottom: "max(3rem, env(safe-area-inset-bottom))",
      }}
    >
      <p className="text-5xl font-bold text-primary mb-2">404</p>
      <h1 className="text-xl font-semibold mb-2">Page not found</h1>
      <p className="text-sm text-muted-foreground mb-6 max-w-sm">
        The page you're looking for doesn't exist or may have moved.
      </p>
      <Button onClick={() => navigate("/")}>Back to dashboard</Button>
    </div>
  );
}
